module.exports = __webpack_public_path__ + "img/64ne.7d7c9584.svg";